module.exports = __webpack_public_path__ + "fonts/f3fc57a.woff2";